/** Problem → solution framing for cold visitors. */
import { AlertTriangle, Calculator, FileSpreadsheet, FolderOpen, MessageSquare, TimerOff } from 'lucide-react';

const PAINS = [
  { icon: FileSpreadsheet, text: 'Managing rotas in spreadsheets' },
  { icon: MessageSquare, text: 'Staff schedules spread across messages' },
  { icon: TimerOff, text: 'Manually checking attendance' },
  { icon: AlertTriangle, text: 'Missing clock-ins and clock-outs' },
  { icon: Calculator, text: 'Calculating hours for payroll' },
  { icon: FolderOpen, text: 'Keeping restaurant information organised' },
];

export function ProblemSection() {
  return (
    <section className="bg-[color:var(--brand-bg-2)] border-y border-[color:var(--brand-border)] scroll-mt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20 grid lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <div>
          <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight" data-testid="marketing-problem-heading">
            Restaurant admin shouldn&apos;t take over your day.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[color:var(--brand-text-muted)] leading-relaxed">
            Most restaurants run their team on a mix of spreadsheets, group chats and paper.
            It works — until it eats your evenings.
          </p>
          <p className="mt-4 text-lg font-display font-semibold text-[color:var(--brand-primary)]" data-testid="marketing-problem-solution-line">
            RotaHQ puts it all in one place.
          </p>
        </div>
        <ul className="surface-card p-5 sm:p-6 space-y-3" data-testid="marketing-problem-pain-list">
          {PAINS.map((pain) => (
            <li key={pain.text} className="flex items-center gap-3 text-sm sm:text-base">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[color:var(--brand-danger-soft)]">
                <pain.icon className="h-4 w-4 text-[color:var(--brand-danger)]" aria-hidden="true" />
              </span>
              {pain.text}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
